/*! Copyright (c) Safe As Milk. All rights reserved. */
import DeferredMedia from "deferred-media";

// Speed: the <video> (and its poster) is inserted right away, but the video file itself
// only starts downloading/playing once the page has finished loading (max 4s wait).
const whenPageLoaded = new Promise((resolve => {
    if (document.readyState === "complete") {
        resolve();
        return;
    }
    window.addEventListener("load", resolve, {
        once: true
    });
    setTimeout(resolve, 4e3);
}));

const playVideo = (lazyVideo, videoElement) => {
    whenPageLoaded.then((() => {
        if (!videoElement.isConnected) return;
        videoElement.setAttribute("autoplay", "autoplay");
        videoElement.preload = "auto";
        if (!lazyVideo.isInView) return;
        videoElement.play().catch((error => {
            if (error.name === "NotAllowedError") {
                videoElement.remove();
            }
        }));
    }));
};

class LazyVideo extends DeferredMedia {
    connectedCallback() {
        const template = this.querySelector("template");
        const templateVideo = template ? template.content.querySelector("video") : null;
        if (templateVideo && document.readyState !== "complete") {
            templateVideo.removeAttribute("autoplay");
            templateVideo.setAttribute("preload", "none");
        }
        const lazyVideoObserver = new IntersectionObserver((entries => {
            entries.forEach((entry => {
                const lazyVideo = entry.target;
                lazyVideo.isInView = entry.isIntersecting;
                if (entry.isIntersecting) {
                    if (!lazyVideo.hasAttribute("loaded")) {
                        lazyVideo.loadContent();
                        const videoElement = lazyVideo.querySelector("video");
                        if (videoElement) playVideo(lazyVideo, videoElement);
                    } else {
                        const videoElement = lazyVideo.querySelector("video");
                        if (videoElement) playVideo(lazyVideo, videoElement);
                    }
                } else {
                    if (!lazyVideo.hasAttribute("loaded")) return;
                    const videoElement = lazyVideo.querySelector("video");
                    if (videoElement) videoElement.pause();
                }
            }));
        }));
        lazyVideoObserver.observe(this);
    }
}

customElements.define("lazy-video", LazyVideo);
//# sourceMappingURL=lazy-video.js.map
